import ResponseNotificationsHeader from "./ResponseNotificationsHeader";
import ResponseNotificationsInternalContent from "./ResponseNotificationsInternalContent";
import ResponseNotificationsRoot from "./ResponseNotificationsRoot";

export const ResponseNotifications = {
  Root: ResponseNotificationsRoot,
  Header: ResponseNotificationsHeader,
  InternalContent: ResponseNotificationsInternalContent
};
